import { Linktrainrelaymixer } from '@linktivity/eticketportal';

const config = new Linktrainrelaymixer.Configuration({
  basePath: import.meta.env.VITE_API_EMOT_HOST,
  middleware: [
    {
      pre: async context => {
        context.init.headers = new Headers({
          'Content-Type': 'application/json'
        });
      }
    }
  ]
});

const linktrainrelay = new Linktrainrelaymixer.LinktrainrelaymixerApi(config);

export default linktrainrelay;
